<!--
 * @description: 
 * @Author: HaoJG
 * @Date: 2021-10-12 09:47:12
 * @Lasteditors: HaoJG
 * @LastEditTime: 2022-03-20 11:32:58
-->
<template>
  <div>
    <div v-if="!isMobile">
      <div class="maintitle">考核自评</div>
      <el-divider></el-divider>
      <el-table :data="alist" row-key="id" border>
        <el-table-column prop="title" width='80' label="工作项"></el-table-column>
        <el-table-column label="具体要求">
          <template v-slot='scope'>
            <span v-html='scope.row.request'></span>
          </template>
        </el-table-column>
        <el-table-column label="达标标准">
          <template v-slot='scope'>
            <span v-html='scope.row.standard'></span>
          </template>
        </el-table-column>
        <el-table-column prop="proportion" label="权重占比" width='80' align="center"></el-table-column>
        <el-table-column label="评分标准">
          <template v-slot='scope'>
            <span v-html='scope.row.points'></span>
          </template>
        </el-table-column>
        <el-table-column label="自评得分" align="center" width='100'>
          <template v-slot="scope">
            <span v-if='scope.row.id===0'>{{scope.row.score}}</span>
            <el-input v-model='scope.row.score' v-else></el-input>
          </template>
        </el-table-column>
        <el-table-column label="理由" align="center">
          <template v-slot="scope">
            <el-input type='textarea' v-model='scope.row.detail' v-if="scope.row.id!=0"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <table class="excellent-table" v-if='needexcellent==1 && excellentlist.length>0'>
        <tr>
          <th style='width:500px;'>优秀标准</th>
          <th>自评理由</th>
        </tr>
        <tr v-for='(item,index) in excellentlist' :key='item.id' :index='index'>
          <td v-html="item.standard" class="text-left"></td>
          <td>
            <span v-if='item.id==0'>{{item.beizhu}}</span>
            <el-input type='textarea' v-model='item.beizhu' v-else></el-input>
          </td>
        </tr>
        <tr>
          <td>结果</td>
          <td>
            <el-select size="mini" v-model="assessinfo.detail[0].excellent">
              <el-option label='不评' :value='0'></el-option>
              <el-option v-for="(item,index) in excellentTypeList" :key='index' :label='item.excellent_title' :value="item.excellent_id"></el-option>
            </el-select>
          </td>
        </tr>
      </table>
    </div>
    <div v-else>
      <div v-for='(item,index) in list' :key='index' class='kaohe-item-mobile'>
        <el-form label-width="80px">
          <el-form-item label="工作项" class="text-left">
            <div class="kaohe-item-mobile-detail">{{item.title}}</div>
          </el-form-item>
          <el-form-item label="具体要求" class="text-left">
            <div class="kaohe-item-mobile-detail" v-html="item.request===''?'无':item.request"></div>
          </el-form-item>
          <el-form-item label="达标标准" class="text-left">
            <div class="kaohe-item-mobile-detail" v-html='item.standard'></div>
          </el-form-item>
          <el-form-item label="权重占比" class="text-left">
            <div class="kaohe-item-mobile-detail">{{item.proportion}}</div>
          </el-form-item>
          <el-form-item label="评分标准" class="text-left">
            <div class="kaohe-item-mobile-detail" v-html='item.points'></div>
          </el-form-item>
          <el-form-item label="自评得分" class="text-left">
            <span v-if='item.id===0'>{{item.score}}</span>
            <el-input v-model='item.score' v-else></el-input>
          </el-form-item>
          <el-form-item label="理由" class="text-left" v-if="item.id!==0">
            <el-input type='textarea' :rows='5' v-model='item.detail'></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class='kaohe-item-div'>
        <el-form label-width="80px">
          <el-form-item label="合计" class='text-left'>
            <span>{{totalScore}}</span>
          </el-form-item>
        </el-form>
      </div>
      <div v-if='needexcellent===1 && excellentlist.length>0'>
        <h3 class="margin-bottom">优秀评比</h3>
        <el-divider></el-divider>
        <div class="kaohe-item-div" v-for='(item,index) in excellentlist' :key='index'>
          <el-form label-width="80px">
            <el-form-item label="优秀标准" class="text-left">
              <span>{{item.standard}}</span>
            </el-form-item>
            <el-form-item label="自评理由" class="text-left">
              <el-input type='textarea' :rows='5' v-model='item.beizhu'></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="kaohe-item-div">
          <el-form label-width="80px">
            <el-form-item label="结果" class="text-left">
              <el-select size="mini" v-model="assessinfo.selfexcellent">
                <el-option label='不评' :value='0'></el-option>
                <el-option v-for="(item,index) in excellentTypeList" :key='index' :label='item.excellent_title' :value="item.excellent_id"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div>
      <el-button @click="submdfy(1)" size='mini' type='info'>暂存</el-button>
      <el-button @click="submdfy(2)" size='mini'>提交</el-button>
      <el-button @click="$router.go(-1)" size='mini'>返回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [], //模板列表
      assessinfo: {

      },
      excellentTypeList: JSON.parse(sessionStorage.getItem('excellentType')),
      needexcellent: 1,
      excellentlist:[],
      totalscore:0,
    };
  },
  computed: {
    score() {
      let temp = [];
      for (let i in this.list) {
        if (this.list[i].id != 0)
          temp.push({
            id: this.list[i].did,
            tiid: parseInt(this.list[i].id),
            proportion: this.list[i].proportion,
            score: this.list[i]['score'] ? parseFloat(this.list[i]['score']) : 0,
            beizhu: this.list[i]['detail'] ? this.list[i][['detail']] : '',
          })
      }
      return temp;
    },
    alist() {
      if (this.list.length === 0) return this.list;
      let temp = {
        id: 0,
        title: '合计',
        score: 0
      }
      for (let item in this.list) {
        temp.score += isNaN(parseFloat(this.list[item].score)) ? 0 : parseFloat(this.list[item].score);
      }
      temp.score = this.assessinfo.detail[0].score = this.totalscore = parseInt(temp.score * 100) / 100;
      return this.list.concat(temp);
    },
    totalScore(){
      console.log(this.alist.at(-1))
      return this.alist.length>0?this.alist.at(-1).score:0;
    }
  },
  methods: {
    getAssessment() {
      this.$axios({
        url: this.HOST + "/kaohe/selfass/getSelfAss",
        method: "post",
        data: {},
      }).then((res) => {
        if (res.data.status === 1) {
          this.list = res.data.list;
          this.assessinfo = res.data.assinfo;
          this.assessinfo.detail[0].excellent = parseInt(this.assessinfo.detail[0].excellent)
          this.needexcellent = res.data.need_excellent;
          this.excellentlist = res.data.excellentlist;
          for(let item in this.assessinfo.detail){
            console.log(this.assessinfo.detail[item])
          }
        }else if(res.data.status === 8){
          this.$message({
            type:'success',
            message:res.data.info
          })
          this.$router.go(-1);
        }
      });
    },
    submdfy(status) { 
      this.$axios({
        url: this.HOST + "/kaohe/selfass/saveSelfAss",
        method: "post",
        data: {
          info: this.assessinfo,
          score: this.score,
          excellent:this.excellentlist,
          status: status,
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.$message({
            type: 'success',
            message: res.data.info
          })
          if (status == 2) {
            this.$router.go(-1);
          } else {
            this.getAssessment();
          }
        }
      });
    },
  },
  created: function () {
    this.getAssessment();
  },
};
</script>